import AddIcon from "@mui/icons-material/Add";
import { Grid, TextField, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../../components/Custom3dotString";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import { soapApiJson } from "../../../../redux/actions/api";
import {
  deleteClinicalNoteById,
  postClinicalNotesWoLoader,
  setApiInProgress,
  updateClinicalNoteWoLoader,
} from "../../../../redux/reducers/clinicSlice";
import {
  hideLoader,
  showLoader,
  showLoaderText,
} from "../../../../redux/reducers/loaderSlice";
import { getPetsCompliantSummaryWoLoader } from "../../../../redux/reducers/petSlice";
import {
  setAudioBlobData,
  setAudRecordingVisbility,
  setAudSaved,
  setSoapNoteDetails,
  setSoapNoteType,
} from "../../../../redux/reducers/recorderSlice";
import { showSnackBar } from "../../../../redux/reducers/snackSlice";
import { addIcon } from "../../../../util/CommonIconStyle";
import {
  fieldMap,
  inpatFieldMap,
  surFieldMap,
} from "../../../../util/arrayMap";
import {
  consolidateShouldBeTrue,
  consolidateShouldBeTrueForOutpatient,
  getArryAsString,
  getInpatNotes,
  getOutpatientNotes,
  toObject,
} from "../../../../util/function";

// Set the app element for accessibility purposes
Modal.setAppElement("#root");

const soapList = [
  "KeyIdentification",
  "Subjective",
  "Objective",
  "Assessment",
  "Plan",
  "Conclusion",
  "KeyIssues",
  "AbnormalFindings",
  "CustomerInstructions",
  "Reminders",
];
const inpatientList = [
  "Summary",
  "Reminders",
  "InstructionsStatus",
  "AbnormalFindings",
  "KeyIssues",
  "RedFlags",
  "OtherUpdates",
  "Observation",
];
const surgeryList = [
  "PreSurgicalDocumentation",
  "IntraSurgicalDocumentation",
  "PostSurgicalDocumentation",
  "OwnerCommunication",
  "AdditionalDocumentation",
];

const nameExten = {
  KeyIdentification: "Diagnosis",
  Subjective: "Subjective",
  Objective: "Objective",
  Assessment: "Assessment",
  Plan: "Plan",
  Conclusion: "Conclusion",
  KeyIssues: "Key Issues",
  AbnormalFindings: "Abnormal Findings",
  CustomerInstructions: "Customer Instructions",
  Reminders: "Reminders",
  Summary: "Summary",
  InstructionsStatus: "Instructions Status",
  RedFlags: "Red Flags",
  OtherUpdates: "Other Updates",
  Observation: "Observation",
  ProgressNotes: "Progress Notes",
  Protocols: "Protocols",
  PreSurgicalDocumentation: "Pre-Surgical Documentation",
  IntraSurgicalDocumentation: "Intra-Surgical Documentation",
  PostSurgicalDocumentation: "Post-Surgical Documentation",
  OwnerCommunication: "Owner Communication",
  AdditionalDocumentation: "Additional Documentation",
};

const initValues = {
  KeyIdentification: "",
  Subjective: "",
  Objective: "",
  Assessment: "",
  Plan: "",
  Conclusion: "",
};

const SoapNotesNew = ({ appointment }) => {
  const dispatch = useDispatch();
  const [recordData, setRecordData] = useState(null);
  const [sections, setSections] = useState(initValues);
  const [delModVsble, setDelModVsble] = useState(false);
  const [modifModVsble, setModfiModVsble] = useState(false);
  const [modContent, setModContent] = useState("");
  const [modConNotValid, setModConNotValid] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [activeTab, setActiveTab] = useState("DailyUpdate");
  const { soapNote, type } = useSelector((state) => state?.recorder);
  const appData = useSelector((state) => state?.pet?.complaintSummary?.data);
  const petRecord = useSelector((state) => state?.pet?.petDetails);
  const { details: clinicDetails } = useSelector((state) => state?.clinic);
  const petData = appointment?.appoinment?.appointmentId
    ? appData?.pet
    : petRecord;
  const petDet = appData?.pet;
  const apnt = appData?.appointment;
  const statusActive =
    typeof petData?.status === "boolean"
      ? petData?.status
      : petData?.status === "Y";
  const apntId =
    appData?.appointment?.appointmentId ??
    appointment?.appoinment?.appointmentId;

  useEffect(() => {
    if (soapNote) {
      dispatch(setAudSaved(false));
      const reqObj = {
        KeyIdentification: soapNote?.DifferentialDiagnosis ?? "",
        DifferentialDiagnosis: soapNote?.DifferentialDiagnosis ?? "",
        Subjective: soapNote?.Subjective,
        Objective: soapNote?.Objective,
        Assessment: soapNote?.Assessment,
        Plan: soapNote?.Plan,
        Conclusion: soapNote?.Conclusion,
        KeyIssues: soapNote?.KeyIssues ?? "",
        AbnormalFindings: soapNote?.AbnormalFindings ?? "",
        CustomerInstructions: soapNote?.CustomerInstructions ?? "",
        Reminders: soapNote?.Reminders ?? "",
        transcript: soapNote?.Transcript ?? "",
        sessionId: soapNote?.sessionId ?? "",
        modificationCount: soapNote?.modificationCount ?? 0,
        blob: soapNote?.blob ?? null,
        type,
        Summary: soapNote?.Summary ?? "",
        InstructionsStatus: soapNote?.InstructionsStatus ?? "",
        RedFlags: soapNote?.RedFlags ?? "",
        OtherUpdates: soapNote?.OtherUpdates ?? "",
        Observation: soapNote?.Observation ?? "",
        PreSurgicalDocumentation: Array.isArray(
          soapNote?.PreSurgicalDocumentation
        )
          ? getArryAsString(soapNote?.PreSurgicalDocumentation ?? [])
          : "",
        IntraSurgicalDocumentation: Array.isArray(
          soapNote?.IntraSurgicalDocumentation
        )
          ? getArryAsString(soapNote?.IntraSurgicalDocumentation ?? [])
          : "",
        PostSurgicalDocumentation: Array.isArray(
          soapNote?.PostSurgicalDocumentation
        )
          ? getArryAsString(soapNote?.PostSurgicalDocumentation ?? [])
          : "",
        OwnerCommunication: Array.isArray(soapNote?.OwnerCommunication)
          ? getArryAsString(soapNote?.OwnerCommunication ?? [])
          : "",
        AdditionalDocumentation: Array.isArray(
          soapNote?.AdditionalDocumentation
        )
          ? getArryAsString(soapNote?.AdditionalDocumentation ?? [])
          : "",
        Protocols: soapNote?.Protocols ?? "",
        ProgressNotes: soapNote?.ProgressNotes ?? "",
        consolidated: false,
      };
      setSections(reqObj);
      setRecordData(reqObj);
      onUpdateNote(reqObj);
      return;
    }
  }, [soapNote]);

  const handleInputChange = (event, section) => {
    setSections({
      ...sections,
      [section]: event?.target?.value,
    });
  };

  const parseNote = (noteString) => {
    const lines = noteString?.split("\n");
    const result = {};
    let currentKey = null;

    for (let line of lines) {
      line = line.trim();
      if (!line) continue;

      const keyMatch = line.match(/^([A-Za-z -]+):$/);
      if (keyMatch) {
        currentKey = keyMatch[1].replace(/-/g, "").replace(/\s+/g, "");
        result[currentKey] = "";
      } else if (currentKey) {
        if (result[currentKey]) {
          result[currentKey] += "\n" + line;
        } else {
          result[currentKey] = line;
        }
      }
    }

    return result;
  };

  const handleFinalize = ({ consolidated = false }) => {
    const form = new FormData();
    form.append("subjective", sections?.Subjective ?? soapNote?.Subjective);
    form.append("objective", sections?.Objective ?? soapNote?.Objective);
    form.append("assessment", sections?.Assessment ?? soapNote?.Assessment);
    form.append("plan", sections?.Plan ?? soapNote?.Plan);
    form.append("conclusion", sections?.Conclusion ?? soapNote?.Conclusion);
    form.append(
      "tag",
      sections?.KeyIdentification ?? soapNote?.DifferentialDiagnosis
    );
    form.append("keyIssues", sections?.KeyIssues ?? soapNote?.KeyIssues);
    form.append(
      "abnormalFindings",
      sections?.AbnormalFindings ?? soapNote?.AbnormalFindings
    );
    form.append(
      "customerInstructions",
      sections?.CustomerInstructions ?? soapNote?.CustomerInstructions
    );
    form.append("reminders", sections?.Reminders ?? soapNote?.reminders);
    form.append("transcript", sections?.transcript ?? soapNote?.transcript);
    form.append("sessionId", sections?.sessionId ?? soapNote?.sessionId);
    form.append(
      "modificationCount",
      sections?.modificationCount ?? soapNote?.modificationCount
    );
    form.append("summary", sections?.Summary ?? soapNote?.Summary);
    form.append(
      "instructionsStatus",
      sections?.InstructionsStatus ?? soapNote?.InstructionsStatus
    );
    form.append("redFlags", sections?.RedFlags ?? soapNote?.RedFlags);
    form.append(
      "otherUpdates",
      sections?.OtherUpdates ?? soapNote?.OtherUpdates
    );
    form.append("observation", sections?.Observation ?? soapNote?.Observation);
    form.append("consolidated", sections?.consolidated ?? consolidated);
    form.append("type", sections?.type ?? selectedNote?.type ?? "outpatient");
    form.append(
      "preSurgicalDocumentation",
      sections?.PreSurgicalDocumentation ?? ""
    );
    form.append(
      "intraSurgicalDocumentation",
      sections?.IntraSurgicalDocumentation ?? ""
    );
    form.append(
      "postSurgicalDocumentation",
      sections?.PostSurgicalDocumentation ?? ""
    );
    form.append("ownerCommunication", sections?.OwnerCommunication ?? "");
    form.append(
      "additionalDocumentation",
      sections?.AdditionalDocumentation ?? ""
    );
    if (sections?.consolidated ?? consolidated) {
      form.append("protocols", sections?.Protocols ?? soapNote?.Protocols);
      form.append(
        "progressNotes",
        sections?.ProgressNotes ?? soapNote?.ProgressNotes
      );
    }
    if (!selectedNote?.id && !selectedNote?.noteId) {
      form.append("objectFile", soapNote?.blob, "recording.webm");
      dispatch(postClinicalNotesWoLoader({ appId: apntId, form })).then(
        (res) => {
          if (res?.payload) {
            dispatch(setSoapNoteDetails(null));
            dispatch(setAudSaved(true));
            dispatch(setAudRecordingVisbility(false));
            dispatch(setAudioBlobData(null));
            setRecordData(null);
            dispatch(getPetsCompliantSummaryWoLoader(apntId));
            dispatch(
              showSnackBar({
                message: "Changes updated successfully!",
                type: "success",
              })
            );
          }
        }
      );
    } else {
      dispatch(
        updateClinicalNoteWoLoader({
          noteId: selectedNote?.id ?? selectedNote?.noteId,
          form,
        })
      ).then((res) => {
        if (res?.payload) {
          dispatch(setSoapNoteDetails(null));
          dispatch(setAudSaved(true));
          dispatch(setAudRecordingVisbility(false));
          dispatch(setAudioBlobData(null));
          setRecordData(null);
          dispatch(getPetsCompliantSummaryWoLoader(apntId));
          setSelectedNote(null);
          dispatch(
            showSnackBar({
              message: "Changes updated successfully!",
              type: "success",
            })
          );
        }
      });
    }
  };

  const handleCreateSoapNote = () => {
    const reqType =
      appData?.appointment?.inpatient && appData?.inpatient?.patientId
        ? activeTab === "DailyUpdate"
          ? "inpatient"
          : activeTab === "SoapNote"
          ? "outpatient"
          : "surgery"
        : "outpatient";
    dispatch(setAudRecordingVisbility(true));
    dispatch(setSoapNoteType(reqType));
    // if (appData?.appointment?.petId) {
    //   dispatch(getPetDetailForSoapByIdWoLoader(appData?.appointment?.petId));
    // }
    localStorage.setItem("appointment", JSON.stringify(appointment));
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
  };

  const onConfirmYes = () => {
    if (!selectedNote?.id && !selectedNote?.noteId) return;
    dispatch(
      deleteClinicalNoteById({
        id: selectedNote?.id ?? selectedNote?.noteId,
        type: selectedNote?.type,
      })
    ).then((res) => {
      if (res?.payload) {
        setDelModVsble(false);
        setRecordData(null);
        setSelectedNote(null);
        dispatch(getPetsCompliantSummaryWoLoader(apntId));
      }
    });
  };

  const onCloseModifMod = () => {
    setModfiModVsble(false);
    setModContent("");
    setModConNotValid(false);
  };

  const getApptDetailsForSoap = () => {
    const reqObj = {
      petName: petDet?.petName ?? apnt?.petName ?? "",
      species: petDet?.petType ?? "",
      breed: petDet?.breed ?? apnt?.breed ?? "",
      age: petDet?.dob ?? apnt?.dob ?? "",
      reproductiveStatus: petDet?.reproductiveStatus ?? "",
      gender: petDet?.gender ?? apnt?.gender ?? "",
      weight: petDet?.weight ?? apnt?.weight ?? "",
      appointmentDateTime: apnt?.appointmentdateTime ?? "",
      bloodGroup: petDet?.bloodGroup ?? apnt?.bloodGroup ?? "",
      temperament: petDet?.temperament ?? apnt?.temperament ?? "",
      color: petDet?.color ?? apnt?.color ?? "",
      rfid: petDet?.rfid ?? apnt?.rfid ?? "",
      veterinaryClinic: clinicDetails?.name ?? "",
      username: petDet?.userName ?? apnt?.userName ?? "",
      vetName: apnt?.doctorName ?? "",
      appointmentId: apnt?.appointmentId ?? "",
    };
    return JSON.stringify(reqObj);
  };

  const onModify = async () => {
    if (modContent?.length === 0 || modContent === "") {
      return setModConNotValid(true);
    }
    if (
      (!selectedNote?.id || !selectedNote?.noteId) &&
      !selectedNote?.sessionId
    )
      return;
    const data = {
      session_id: selectedNote?.sessionId,
      user_feedback: modContent,
      case_type: selectedNote?.type ?? "outpatient",
      appt_details: getApptDetailsForSoap(),
    };
    dispatch(showLoader());
    dispatch(showLoaderText("Please wait while we generate the SOAP notes"));
    soapApiJson.post("/modify-soap-note/", data).then((res) => {
      if (res?.data?.modified_soap_note) {
        try {
          const reqObj = JSON.parse(res?.data?.modified_soap_note);
          const apiObj = {
            KeyIdentification: reqObj?.DifferentialDiagnosis ?? "",
            DifferentialDiagnosis: reqObj?.DifferentialDiagnosis ?? "",
            Subjective: reqObj?.Subjective ?? "",
            Objective: reqObj?.Objective ?? "",
            Assessment: reqObj?.Assessment ?? "",
            Plan: reqObj?.Plan ?? "",
            Conclusion: reqObj?.Conclusion ?? "",
            KeyIssues: reqObj?.KeyIssues ?? "",
            AbnormalFindings: reqObj?.AbnormalFindings ?? "",
            CustomerInstructions: reqObj?.CustomerInstructions ?? "",
            Reminders: reqObj?.Reminders ?? "",
            transcript: reqObj?.Transcript ?? "",
            sessionId: res?.data?.session_id ?? selectedNote?.sessionId ?? "",
            modificationCount: res?.data?.modification_count ?? 1,
            type: selectedNote?.type ?? "outpatient",
            Summary: reqObj?.Summary ?? "",
            InstructionsStatus: reqObj?.InstructionsStatus ?? "",
            RedFlags: reqObj?.RedFlags ?? "",
            OtherUpdates: reqObj?.OtherUpdates ?? "",
            Observation: reqObj?.Observation ?? "",
            consolidated: selectedNote?.consolidated ?? false,
          };
          if (selectedNote?.type === "surgery") {
            apiObj.PreSurgicalDocumentation = Array.isArray(
              reqObj?.PreSurgicalDocumentation
            )
              ? getArryAsString(reqObj?.PreSurgicalDocumentation ?? [])
              : "";
            apiObj.IntraSurgicalDocumentation = Array.isArray(
              reqObj?.IntraSurgicalDocumentation
            )
              ? getArryAsString(reqObj?.IntraSurgicalDocumentation ?? [])
              : "";
            apiObj.PostSurgicalDocumentation = Array.isArray(
              reqObj?.PostSurgicalDocumentation
            )
              ? getArryAsString(reqObj?.PostSurgicalDocumentation ?? [])
              : "";
            apiObj.OwnerCommunication = Array.isArray(
              reqObj?.OwnerCommunication
            )
              ? getArryAsString(reqObj?.OwnerCommunication ?? [])
              : "";
            apiObj.AdditionalDocumentation = Array.isArray(
              reqObj?.AdditionalDocumentation
            )
              ? getArryAsString(reqObj?.AdditionalDocumentation ?? [])
              : "";
          }
          onUpdateNote(apiObj);
          setSections(apiObj);
          dispatch(hideLoader());
          dispatch(showLoaderText(""));
        } catch (err) {
          dispatch(hideLoader());
          dispatch(showLoaderText(""));
        }
      }
      dispatch(hideLoader());
      dispatch(showLoaderText(""));
    });
  };

  const onUpdateNote = ({
    Subjective = "",
    Objective = "",
    Assessment = "",
    Plan = "",
    Conclusion = "",
    DifferentialDiagnosis = "",
    KeyIssues = "",
    AbnormalFindings = "",
    CustomerInstructions = "",
    Reminders = "",
    sessionId = "",
    transcript = "",
    modificationCount = 0,
    blob = null,
    type = "outpatient",
    Summary = "",
    InstructionsStatus = "",
    RedFlags = "",
    OtherUpdates = "",
    Observation = "",
    consolidated = false,
    Protocols = "",
    ProgressNotes = "",
    PreSurgicalDocumentation = "",
    IntraSurgicalDocumentation = "",
    PostSurgicalDocumentation = "",
    OwnerCommunication = "",
    AdditionalDocumentation = "",
  }) => {
    const form = new FormData();
    form.append("subjective", Subjective);
    form.append("objective", Objective);
    form.append("assessment", Assessment);
    form.append("plan", Plan);
    form.append("conclusion", Conclusion);
    form.append("tag", DifferentialDiagnosis);
    form.append("keyIssues", KeyIssues);
    form.append("abnormalFindings", AbnormalFindings);
    form.append("customerInstructions", CustomerInstructions);
    form.append("reminders", Reminders);
    form.append("summary", Summary);
    form.append("instructionsStatus", InstructionsStatus);
    form.append("redFlags", RedFlags);
    form.append("otherUpdates", OtherUpdates);
    form.append("observation", Observation);
    form.append("sessionId", sessionId);
    form.append("modificationCount", modificationCount);
    form.append("type", type);
    form.append("consolidated", consolidated);
    form.append("preSurgicalDocumentation", PreSurgicalDocumentation);
    form.append("intraSurgicalDocumentation", IntraSurgicalDocumentation);
    form.append("postSurgicalDocumentation", PostSurgicalDocumentation);
    form.append("ownerCommunication", OwnerCommunication);
    form.append("additionalDocumentation", AdditionalDocumentation);
    if (consolidated) {
      form.append("protocols", Protocols);
      form.append("progressNotes", ProgressNotes);
    }
    form.append("transcript", transcript);
    if (!selectedNote?.id && !selectedNote?.noteId) {
      if (blob) {
        form.append("objectFile", soapNote?.blob, "recording.webm");
      }
      dispatch(postClinicalNotesWoLoader({ appId: apntId, form })).then(
        (res) => {
          if (res?.payload) {
            setSelectedNote(consolidated ? null : res?.payload);
            dispatch(setSoapNoteDetails(null));
            dispatch(setAudSaved(true));
            dispatch(setAudRecordingVisbility(false));
            dispatch(setAudioBlobData(null));
            dispatch(getPetsCompliantSummaryWoLoader(apntId));
            dispatch(
              showSnackBar({
                message: "Changes updated successfully!",
                type: "success",
              })
            );
          }
        }
      );
    } else {
      dispatch(
        updateClinicalNoteWoLoader({
          noteId: selectedNote?.id ?? selectedNote?.noteId,
          form,
        })
      ).then((res) => {
        if (res?.payload) {
          setSelectedNote(consolidated ? null : res?.payload);
          onCloseModifMod();
          dispatch(getPetsCompliantSummaryWoLoader(apntId));
          dispatch(
            showSnackBar({
              message: "Changes updated successfully!",
              type: "success",
            })
          );
        }
      });
    }
  };

  const onChangeContent = (e) => {
    setModContent(e?.target?.value);
    setModConNotValid(e?.target?.value?.length === 0);
  };

  const onEditNote = (cn) => {
    setSelectedNote(cn);
    dispatch(setAudSaved(true));
    dispatch(setSoapNoteType(cn?.type ?? "outpatient"));
    const reqObj = {
      KeyIdentification: cn?.tag ?? "",
      Subjective: cn?.subjective ?? "",
      Objective: cn?.objective ?? "",
      Assessment: cn?.assessment ?? "",
      Plan: cn?.plan ?? "",
      Conclusion: cn?.conclusion ?? "",
      KeyIssues: cn?.keyIssues ?? "",
      AbnormalFindings: cn?.abnormalFindings ?? "",
      CustomerInstructions: cn?.customerInstructions ?? "",
      Reminders: cn?.reminders ?? "",
      transcript: cn?.transcript ?? "",
      sessionId: cn?.sessionId,
      modificationCount: cn?.modificationCount,
      Summary: cn?.summary ?? "",
      InstructionsStatus: cn?.instructionsStatus ?? "",
      RedFlags: cn?.redFlags ?? "",
      OtherUpdates: cn?.otherUpdates ?? "",
      Observation: cn?.observation ?? "",
      consolidated: cn?.consolidated ?? false,
      Protocols: cn?.protocols ?? "",
      ProgressNotes: cn?.progressNotes ?? "",
      PreSurgicalDocumentation: cn?.preSurgicalDocumentation ?? "",
      IntraSurgicalDocumentation: cn?.intraSurgicalDocumentation ?? "",
      PostSurgicalDocumentation: cn?.postSurgicalDocumentation ?? "",
      OwnerCommunication: cn?.ownerCommunication ?? "",
      AdditionalDocumentation: cn?.additionalDocumentation ?? "",
    };
    setSections(reqObj);
    setRecordData(reqObj);
  };

  const onConsolidateSoap = async () => {
    const typ =
      appData?.appointment?.inpatient && appData?.inpatient?.patientId
        ? activeTab === "DailyUpdate"
          ? "inpatient"
          : activeTab === "SoapNote"
          ? "outpatient"
          : "surgery"
        : "outpatient";
    const reqList =
      typ === "outpatient"
        ? appData?.clinicalNotes?.filter(
            (cn) =>
              cn?.appointmentId ===
                (apntId ?? appointment?.appoinment?.appointmentId) &&
              !cn?.consolidated
          )
        : appData?.inpatientNotes?.filter(
            (li) =>
              li?.appointmentId ===
                (apntId ?? appointment?.appoinment?.appointmentId) &&
              li?.type?.toLowerCase() === typ?.toLowerCase() &&
              moment(new Date(li?.createdDate)).format("YYYY-MM-DD") ===
                moment(new Date()).format("YYYY-MM-DD") &&
              !li?.consolidated
          );
    if (reqList?.length === 0 || reqList?.length === 1) return;
    const soap_notes = reqList?.map((obj) =>
      (typ === "outpatient"
        ? fieldMap
        : typ === "inpatient"
        ? inpatFieldMap
        : surFieldMap
      )
        ?.map(([k, src]) => {
          const raw = (obj[src] ?? "").toString();
          const safe = raw?.replace(/\r?\n/g, " ")?.replace(/'/g, "\\'");
          return `${k}:'${safe}'`;
        })
        ?.join(",")
    );
    const data = {
      soap_notes,
      case_type: typ,
      appt_details: getApptDetailsForSoap(),
    };
    if (
      // reqList?.[0]?.type === "surgery" ||
      reqList?.[0]?.type === "inpatient"
    ) {
      const combRedFlags = reqList?.map((li) => li?.redFlags)?.join(", ");
      const combInstFlags = reqList
        ?.map((li) => li?.instructionsStatus)
        ?.join(", ");
      if (combInstFlags?.length > 0) {
        data.Instructions = combInstFlags ?? "";
      }
      if (combRedFlags?.length > 0) {
        data.RedFlags = combRedFlags ?? "";
      }
    }
    dispatch(showLoader());
    dispatch(showLoaderText("Please wait while we consolidate the SOAP notes"));
    dispatch(
      setApiInProgress({ apiType: "consolidateSoap", inProgress: true })
    );
    soapApiJson.post("/consolidate-soap-notes", data).then((res) => {
      if (res?.status === 200) {
        dispatch(
          setApiInProgress({ apiType: "consolidateSoap", inProgress: false })
        );
        if (res?.data?.consolidated_soap_note) {
          const reqObj = toObject(res?.data?.consolidated_soap_note);
          dispatch(hideLoader());
          dispatch(showLoaderText(""));
          const apiObj = {
            ...reqObj,
            sessionId: res?.data?.session_id ?? reqObj?.session_id ?? "",
            modificationCount:
              res?.data?.modification_count ?? reqObj?.modification_count ?? 0,
            consolidated: true,
            type: typ,
            Protocols: reqObj?.Protocols ?? "",
            ProgressNotes: reqObj?.ProgressNotes ?? "",
            Conclusion: reqObj?.Conclusion ?? "",
          };
          if (typ === "surgery") {
            apiObj.PreSurgicalDocumentation = Array.isArray(
              reqObj?.PreSurgicalDocumentation
            )
              ? getArryAsString(reqObj?.PreSurgicalDocumentation ?? [])
              : "";
            apiObj.IntraSurgicalDocumentation = Array.isArray(
              reqObj?.IntraSurgicalDocumentation
            )
              ? getArryAsString(reqObj?.IntraSurgicalDocumentation ?? [])
              : "";
            apiObj.PostSurgicalDocumentation = Array.isArray(
              reqObj?.PostSurgicalDocumentation
            )
              ? getArryAsString(reqObj?.PostSurgicalDocumentation ?? [])
              : "";
            apiObj.OwnerCommunication = Array.isArray(
              reqObj?.OwnerCommunication
            )
              ? getArryAsString(reqObj?.OwnerCommunication ?? [])
              : "";
            apiObj.AdditionalDocumentation = Array.isArray(
              reqObj?.AdditionalDocumentation
            )
              ? getArryAsString(reqObj?.AdditionalDocumentation ?? [])
              : "";
          }
          onUpdateNote(apiObj);
        } else {
          dispatch(
            setApiInProgress({ apiType: "consolidateSoap", inProgress: false })
          );
          dispatch(hideLoader());
          dispatch(showLoaderText(""));
        }
      } else {
        dispatch(
          setApiInProgress({ apiType: "consolidateSoap", inProgress: false })
        );
        dispatch(hideLoader());
        dispatch(showLoaderText(""));
      }
    });
  };

  const getReqSoapList = (isConsolidated = false) => {
    return appData?.appointment?.inpatient && appData?.inpatient?.patientId
      ? activeTab === "SoapNote"
        ? getOutpatientNotes(
            appData?.clinicalNotes,
            appData?.appointment?.appointmentId
          )
        : getInpatNotes(
            appData?.inpatientNotes,
            appData?.appointment?.appointmentId
          )
      : getOutpatientNotes(
          appData?.clinicalNotes,
          appData?.appointment?.appointmentId
        );
  };

  const onGenerateBill = async () => {
    const reqSoap = getReqSoapList(true);
    if (!reqSoap) return;
    const soap_note = fieldMap
      ?.map(([k, src]) => {
        const raw = (reqSoap[src] ?? "").toString();
        const safe = raw?.replace(/\r?\n/g, " ")?.replace(/'/g, "\\'");
        return `${k}:'${safe}'`;
      })
      ?.join(",");
    dispatch(showLoader());
    dispatch(showLoaderText("Please wait while we generate the bill"));
    const res = await soapApiJson.post("/billing/complete", {
      soap_note,
      appt_details: getApptDetailsForSoap(),
    });
    console.log("res", res);

    dispatch(hideLoader());
    dispatch(showLoaderText(""));
  };

  const onChangeTab = (tab) => {
    setActiveTab(tab);
  };

  const renderConsolidateButton = () => {
    const inpatType = activeTab === "DailyUpdate" ? "inpatient" : "surgery";
    const conShow =
      appData?.appointment?.inpatient && appData?.inpatient?.patientId
        ? activeTab === "SoapNote"
          ? consolidateShouldBeTrueForOutpatient(
              appData?.clinicalNotes,
              apntId ?? appointment?.appoinment?.appointmentId
            )
          : consolidateShouldBeTrue(appData?.inpatientNotes, inpatType)
        : consolidateShouldBeTrueForOutpatient(
            appData?.clinicalNotes,
            apntId ?? appointment?.appoinment?.appointmentId
          );
    return conShow;
  };

  return (
    <>
      <div className="w100Per mt10 ph20">
        {recordData ? (
          <>
            {(type === "outpatient"
              ? soapList
              : type === "inpatient"
              ? [
                  ...inpatientList,
                  ...[
                    ...(recordData?.consolidated
                      ? ["ProgressNotes", "Conclusion", "Protocols"]
                      : []),
                  ],
                ]
              : surgeryList
            )?.map((section, i) => (
              <div key={section} className="mt20">
                <div className="flex-row-between-align-center">
                  <div className="heading-fw600 fs14 black">
                    {nameExten[section]}
                  </div>
                </div>
                <div className="mt10">
                  <TextField
                    fullWidth
                    value={sections?.[section]}
                    onChange={(event) => handleInputChange(event, section)}
                    multiline={section !== "KeyIdentification"}
                  />
                </div>
              </div>
            ))}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="clinic-mod-btn-pos mt20 mb10">
                {(selectedNote
                  ? selectedNote?.modificationCount
                  : sections?.modificationCount) > 0 ? null : (
                  <div>
                    <CustomButton
                      text="Modify"
                      smallBtn
                      onClick={() => setModfiModVsble(true)}
                    />
                  </div>
                )}
                {!selectedNote?.reviewed ? (
                  <div className="ml10">
                    <CustomButton
                      text="Discard"
                      smallBtn
                      onClick={() => setDelModVsble(true)}
                      redBtn
                    />
                  </div>
                ) : null}
                <div className="ml10">
                  <CustomButton text="Save" smallBtn onClick={handleFinalize} />
                </div>
              </div>
            </Grid>
          </>
        ) : (
          <div>
            {appData?.appointment?.inpatient && (
              <div className="flex-row mb10">
                <div
                  className="ph10pv3"
                  onClick={() => onChangeTab("DailyUpdate")}
                >
                  <div
                    className={`flex-center cursor ${
                      activeTab === "DailyUpdate"
                        ? "pet-det-sel-tab"
                        : "pet-det-un-sel-tab"
                    }`}
                  >
                    Daily Update
                  </div>
                </div>
                <div
                  className="ph10pv3"
                  onClick={() => onChangeTab("SoapNote")}
                >
                  <div
                    className={`flex-center cursor ${
                      activeTab === "SoapNote"
                        ? "pet-det-sel-tab"
                        : "pet-det-un-sel-tab"
                    }`}
                  >
                    SOAP Note
                  </div>
                </div>
                <div
                  className="ph10pv3"
                  onClick={() => onChangeTab("SurgerySOAP")}
                >
                  <div
                    className={`flex-center cursor ${
                      activeTab === "SurgerySOAP"
                        ? "pet-det-sel-tab"
                        : "pet-det-un-sel-tab"
                    }`}
                  >
                    Surgery SOAP
                  </div>
                </div>
                {appData?.appointment?.checkOut !== "Y" && (
                  <div className="flex1-end">
                    <div
                      className="flex-row-ali-cen cursor"
                      onClick={() => handleCreateSoapNote("inpatient")}
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={addIcon} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Add
                      </Typography>
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* {appData?.appointment?.inpatient &&
            appData?.inpatient?.patientId ? (
              <div
                className={`flex1-end ${
                  consolidateShouldBeTrue(
                    appData?.inpatientNotes,
                    "inpatient"
                  ) ||
                  consolidateShouldBeTrue(appData?.inpatientNotes, "surgery")
                    ? "mb20"
                    : ""
                }`}
              >
                {consolidateShouldBeTrue(
                  appData?.inpatientNotes,
                  "inpatient"
                ) ? (
                  <div>
                    <CustomButton
                      text="Consolidate Daily SOAP"
                      onClick={() => onConsolidateSoap("inpatient")}
                      smallBtn
                    />
                  </div>
                ) : null}
                {consolidateShouldBeTrue(appData?.inpatientNotes, "surgery") ? (
                  <div className="ml15">
                    <CustomButton
                      text="Consolidate Surgery SOAP"
                      onClick={() => onConsolidateSoap("surgery")}
                      smallBtn
                    />
                  </div>
                ) : null}
              </div>
            ) : null} */}
            <div className="flex-row-ali-cen ph20">
              <div
                className={appData?.inpatient?.patientId ? "w40Per" : "w60Per"}
              >
                <Typography className="font-bold blue-color fs12">
                  Name
                </Typography>
              </div>
              {appData?.inpatient?.patientId ? (
                <div className="w20Per">
                  <Typography className="font-bold blue-color fs12">
                    Type
                  </Typography>
                </div>
              ) : null}
              <div className="w20Per">
                <Typography className="font-bold blue-color fs12">
                  Recorded By
                </Typography>
              </div>
              <div className="w20Per">
                <Typography className="font-bold blue-color fs12">
                  Recorded Date/Time
                </Typography>
              </div>
            </div>
            <div className="blue-hor-split mt5" />
            {getReqSoapList()?.length > 0
              ? getReqSoapList()?.map((cn, i) => {
                  return (
                    <div
                      className="flex-row-ali-cen ph20 mt10"
                      key={cn?.id ?? cn?.noteId}
                    >
                      <div
                        className={
                          appData?.inpatient?.patientId ? "w40Per" : "w60Per"
                        }
                      >
                        <div
                          className="flex-row-ali-cen"
                          onClick={() => onEditNote(cn)}
                        >
                          <Custom3dotString
                            str={`Note ${getReqSoapList()?.length - i}${
                              cn?.consolidated ? " (Consolidated)" : ""
                            }`}
                            className="txt-semi-bold blue-color fs12 underline cursor"
                            length={25}
                          />
                        </div>
                      </div>
                      {appData?.inpatient?.patientId ? (
                        <div className="w20Per">
                          <Typography className="font-medium gray34 fs12">
                            {activeTab === "SoapNote"
                              ? "SOAP Note"
                              : cn?.type === "inpatient"
                              ? "Daily Update"
                              : "Surgery SOAP"}
                          </Typography>
                        </div>
                      ) : null}
                      <div className="w20Per">
                        <Typography className="font-medium gray34 fs12">
                          {cn?.userName ?? ""}
                        </Typography>
                      </div>
                      <div className="w20Per">
                        <Typography className="font-medium gray34 fs12">
                          {moment(new Date(cn?.createdDate)).format(
                            "DD MMM YYYY, HH:mm"
                          )}
                        </Typography>
                      </div>
                    </div>
                  );
                })
              : null}
            {appData?.appointment?.checkOut !== "Y" ? (
              <div className="flex-row-ali-cen mt20">
                {appData?.appointment?.inpatient &&
                appData?.inpatient?.patientId ? null : (
                  // <>
                  //   <div
                  //     className="flex-row-ali-cen cursor"
                  //     onClick={() => handleCreateSoapNote("inpatient")}
                  //   >
                  //     <div className="flex-center plus-icon">
                  //       <AddIcon sx={addIcon} />
                  //     </div>
                  //     <Typography className="blue-color fs16 ml5 font-bold">
                  //       Daily Update
                  //     </Typography>
                  //   </div>
                  //   <div
                  //     className="flex-row-ali-cen cursor ml30"
                  //     onClick={() => handleCreateSoapNote("surgery")}
                  //   >
                  //     <div className="flex-center plus-icon">
                  //       <AddIcon sx={addIcon} />
                  //     </div>
                  //     <Typography className="blue-color fs16 ml5 font-bold">
                  //       Surgery SOAP
                  //     </Typography>
                  //   </div>
                  // </>
                  <div className="flex-row-ali-cen">
                    <div
                      className="flex-row-ali-cen cursor"
                      onClick={() => handleCreateSoapNote("outpatient")}
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={addIcon} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Record SOAP
                      </Typography>
                    </div>
                    {/* {appData?.inpatient?.patientId &&
                    appData?.appointment?.inpatient ? null : (
                      <>
                        {consolidateShouldBeTrueForOutpatient(
                          appData?.clinicalNotes,
                          apntId ?? appointment?.appoinment?.appointmentId
                        ) ? (
                          <div className="ml15">
                            <CustomButton
                              text="Consolidate SOAP"
                              onClick={() => onConsolidateSoap("outpatient")}
                              smallBtn
                            />
                          </div>
                        ) : null}
                        // {getReqSoapList(true) ? (
                        //   <div className="ml15">
                        //     <CustomButton
                        //       text="Generate Bill"
                        //       onClick={onGenerateBill}
                        //       smallBtn
                        //     />
                        //   </div>
                        // ) : null}
                      </>
                    )} */}
                  </div>
                )}
              </div>
            ) : null}
            {appData?.appointment?.checkOut !== "Y" &&
              renderConsolidateButton() && (
                <div className="flex-row-ali-cen mt20">
                  <div>
                    <CustomButton
                      text={`Consolidate ${
                        appData?.appointment?.inpatient &&
                        appData?.inpatient?.patientId
                          ? activeTab === "DailyUpdate"
                            ? "Daily"
                            : activeTab === "SoapNote"
                            ? ""
                            : "Surgery"
                          : ""
                      } SOAP`}
                      onClick={() => onConsolidateSoap("outpatient")}
                      smallBtn
                    />
                  </div>
                </div>
              )}
          </div>
        )}
      </div>
      <CustomModal
        open={modifModVsble}
        onClose={onCloseModifMod}
        header="Modify"
        modal
        modalWidth={40}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomTextField
              fullWidth
              handleChange={(e) => onChangeContent(e)}
              value={modContent}
              multiline
              error={modConNotValid}
              helperText={modConNotValid ? "Content is required" : ""}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-center mb20">
              <div>
                <CustomButton text="Save" smallBtn onClick={onModify} />
              </div>
            </div>
          </Grid>
        </Grid>
      </CustomModal>
      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Discard"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to discard the note?
        </Typography>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-center mb10 mt15">
            <div className="mr10">
              <CustomButton text="Yes" redBtn smallBtn onClick={onConfirmYes} />
            </div>
            <div className="ml10">
              <CustomButton
                text="No"
                onClick={() => setDelModVsble(false)}
                smallBtn
              />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default SoapNotesNew;
